import { selectCountries } from "../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";
import { provinces } from "../../../../shared";
import {
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../utilities/masks";
import { selectApplicantAvailableCities } from "../../Applicant/applicant.selectors";
import { setAvailableCities } from "../../Applicant/applicant.slice";
import {
  selectIncidentCircumstancesData,
  selectUIData,
} from "../incident.selectors";
import { onCountryChange } from "../incident.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INCIDENT_CIRCUMSTANCES,
  selector: selectIncidentCircumstancesData,
  redirect: Url.AC_PERPETRATOR,
  content: [
    {
      title: "Okoliczności zdarzenia",
      sections: [
        {
          id: "incident-circumstances-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.DATE_PICKER,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_DATE,
              required: true,
              isSubmitted: false,
              label: "Data zdarzenia",
              defaultValue: null,
            },
            {
              type: FormElement.TIME_PICKER,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_HOUR,
              required: true,
              label: "Godzina zdarzenia",
            },
          ],
        },
        {
          id: "incident-circumstances-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_PLACE,
              required: true,
              label: "Miejsce zdarzenia",
              placeholder:
                "Podaj dane miejsca zdarzenia: nazwa ulicy lub skrzyżowanie ulic, " +
                "nr domu, nazwa ronda, lub inny charakterystyczny punkt np. 245 km trasy A2.",
              limit: 250,
            },
          ],
        },
        {
          id: "incident-circumstances-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY,
              onChange: onCountryChange,
              items: selectCountries,
              required: true,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              label: "Województwo",
              required: true,
              items: [...provinces],
            },
          ],
        },
        {
          id: "incident-circumstances-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_ZIP_CODE_PL,
              label: "Kod pocztowy",
              required: true,
              defaultValue: "00-000",
              tooltip:
                "Jeśli nie znasz kodu pocztowego pozostaw zera, zaznacz checkbox 'Inne' i wpisz miejscowość ręcznie.",
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_ZIP_CODE_PL,
              label: "Kod pocztowy",
              required: false,
            },
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_CITY,
              required: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectApplicantAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_CITY,
              required: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              label: "Miejscowość",
            },
          ],
        },
        {
          id: "incident-circumstances-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_DESCRIPTION,
              required: true,
              placeholder:
                "Opisz okoliczności i przebieg zdarzenia (np. Zatrzymałem się na czerwonym świetle, " +
                "a sprawca nie zachował należytej ostrożności i uderzył w tył mojego auta)",
              limit: 10000,
              label: "Opis zdarzenia",
            },
          ],
        },
      ],
    },
  ],
};
